export const ROLES = {
    ADMIN : "Admin",
    BID_COORDINATOR : "Bid Coordinator",
    PROJECT_MANAGER : "Project Manager",
    ASSISTANT_PROJECT_MANAGER : "Assistant Project Manager",
    SMT: "SMT",
    COMMERCIAL : "Commercial"
} as const;
 
export type Role = typeof ROLES[keyof typeof ROLES];
 
export const ALL_ROLES = Object.values(ROLES);
 
export const ROLE_GROUPS = {

  ADMIN_ONLY: [ROLES.ADMIN],
  BASELINE: [ROLES.ADMIN, ROLES.COMMERCIAL, ROLES.SMT],
  INVOICING: [ROLES.PROJECT_MANAGER],
  INVOICE_LIST: [ROLES.SMT],
  ALL_ROLES: ALL_ROLES,
  VIEW_INVOICE: [ROLES.PROJECT_MANAGER,ROLES.SMT],
  BASELINE_VIEW: [ROLES.ADMIN, ROLES.COMMERCIAL, ROLES.SMT,ROLES.PROJECT_MANAGER]
};

